export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

// User types
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const TOGGLE_USER_STATUS_SUCCESS = 'TOGGLE_USER_STATUS_SUCCESS';
export const TOGGLE_USER_STATUS_REQUEST = 'TOGGLE_USER_STATUS_REQUEST';
export const TOGGLE_USER_STATUS_FAILURE = 'TOGGLE_USER_STATUS_FAILURE';
export const FETCH_USER_ATTACHMENTS_REQUEST = 'FETCH_USER_ATTACHMENTS_REQUEST';
export const FETCH_USER_ATTACHMENTS_SUCCESS = 'FETCH_USER_ATTACHMENTS_SUCCESS';
export const FETCH_USER_ATTACHMENTS_FAILURE = 'FETCH_USER_ATTACHMENTS_FAILURE';



// Center types
export const FETCH_CENTERS_REQUEST = 'FETCH_CENTERS_REQUEST';
export const FETCH_CENTERS_SUCCESS = 'FETCH_CENTERS_SUCCESS';
export const FETCH_CENTERS_FAILURE = 'FETCH_CENTERS_FAILURE';
export const ADD_CENTER_REQUEST = 'ADD_CENTER_REQUEST';
export const ADD_CENTER_SUCCESS = 'ADD_CENTER_SUCCESS';
export const ADD_CENTER_FAILURE = 'ADD_CENTER_FAILURE';
export const UPDATE_CENTER_REQUEST = 'UPDATE_CENTER_REQUEST';
export const UPDATE_CENTER_SUCCESS = 'UPDATE_CENTER_SUCCESS';
export const UPDATE_CENTER_FAILURE = 'UPDATE_CENTER_FAILURE';
export const DELETE_CENTER_REQUEST = 'DELETE_CENTER_REQUEST';
export const DELETE_CENTER_SUCCESS = 'DELETE_CENTER_SUCCESS';
export const DELETE_CENTER_FAILURE = 'DELETE_CENTER_FAILURE';
export const TOGGLE_CENTER_STATUS_SUCCESS = 'TOGGLE_CENTER_STATUS_SUCCESS';

// grievance types
export const FETCH_GRIEVANCES_REQUEST = 'FETCH_GRIEVANCES_REQUEST';
export const FETCH_GRIEVANCES_SUCCESS = 'FETCH_GRIEVANCES_SUCCESS';
export const FETCH_GRIEVANCES_FAILURE = 'FETCH_GRIEVANCES_FAILURE';

export const FETCH_GRIEVANCE_DETAILS_REQUEST = 'FETCH_GRIEVANCE_DETAILS_REQUEST';
export const FETCH_GRIEVANCE_DETAILS_SUCCESS = 'FETCH_GRIEVANCE_DETAILS_SUCCESS';
export const FETCH_GRIEVANCE_DETAILS_FAILURE = 'FETCH_GRIEVANCE_DETAILS_FAILURE';

export const UPDATE_GRIEVANCE_STATUS_REQUEST = 'UPDATE_GRIEVANCE_STATUS_REQUEST';
export const UPDATE_GRIEVANCE_STATUS_SUCCESS = 'UPDATE_GRIEVANCE_STATUS_SUCCESS';
export const UPDATE_GRIEVANCE_STATUS_FAILURE = 'UPDATE_GRIEVANCE_STATUS_FAILURE';

export const FORWARD_GRIEVANCE_REQUEST = 'FORWARD_GRIEVANCE_REQUEST';
export const FORWARD_GRIEVANCE_SUCCESS = 'FORWARD_GRIEVANCE_SUCCESS';
export const FORWARD_GRIEVANCE_FAILURE = 'FORWARD_GRIEVANCE_FAILURE';

//  fetch master status
export const FETCH_MASTER_STATUS_REQUEST = 'FETCH_MASTER_STATUS_REQUEST';
export const FETCH_MASTER_STATUS_SUCCESS = 'FETCH_MASTER_STATUS_SUCCESS';
export const FETCH_MASTER_STATUS_FAILURE = 'FETCH_MASTER_STATUS_FAILURE';

// grants
export const FETCH_GRANTS_REQUEST = 'FETCH_GRANTS_REQUEST';
export const FETCH_GRANTS_SUCCESS = 'FETCH_GRANTS_SUCCESS';
export const FETCH_GRANTS_FAILURE = 'FETCH_GRANTS_FAILURE';
export const UPDATE_GRANT_STATUS_SUCCESS = 'UPDATE_GRANT_STATUS_SUCCESS';
export const FETCH_ALL_GRANTS_SUCCESS = 'FETCH_ALL_GRANTS_SUCCESS';
export const FETCH_GRANT_STATUS_OPTIONS_SUCCESS = 'FETCH_GRANT_STATUS_OPTIONS_SUCCESS';

// Master grants types
export const FETCH_MASTER_GRANTS_REQUEST = 'FETCH_MASTER_GRANTS_REQUEST';
export const FETCH_MASTER_GRANTS_SUCCESS = 'FETCH_MASTER_GRANTS_SUCCESS';
export const FETCH_MASTER_GRANTS_FAILURE = 'FETCH_MASTER_GRANTS_FAILURE';
export const FETCH_GRANT_DETAILS_SUCCESS = 'FETCH_GRANT_DETAILS_SUCCESS';
export const FETCH_GRANT_HISTORY_SUCCESS = 'FETCH_GRANT_HISTORY_SUCCESS';
export const FETCH_GRANT_HISTORY_FAILURE = 'FETCH_GRANT_HISTORY_FAILURE';

// notifications
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

// master centers
export const SET_SELECTED_CENTER = 'SET_SELECTED_CENTER';

// Status master types
export const FETCH_STATUS_MASTER_REQUEST = 'FETCH_STATUS_MASTER_REQUEST';
export const FETCH_STATUS_MASTER_SUCCESS = 'FETCH_STATUS_MASTER_SUCCESS';
export const FETCH_STATUS_MASTER_FAILURE = 'FETCH_STATUS_MASTER_FAILURE';


// fetch applicant details

export const FETCH_APPLICANT_DETAILS = 'FETCH_APPLICANT_DETAILS';

export const FETCH_GRIEVANCE_ESCALATION_MATRIX_REQUEST = 'FETCH_GRIEVANCE_ESCALATION_MATRIX_REQUEST'
export const FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS = 'FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS'
export const FETCH_GRIEVANCE_ESCALATION_MATRIX_FAILURE = 'FETCH_GRIEVANCE_ESCALATION_MATRIX_FAILURE'

// events
export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST'
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS'
export const FETCH_EVENTS_FAILURE = 'FETCH_EVENTS_FAILURE'

export const FETCH_POLICIES_REQUEST = 'FETCH_POLICIES_REQUEST'
export const FETCH_POLICIES_SUCCESS = 'FETCH_POLICIES_SUCCESS'
export const FETCH_POLICIES_FAILURE = 'FETCH_POLICIES_FAILURE'

// Policy CRUD types
export const ADD_POLICY_REQUEST = 'ADD_POLICY_REQUEST'
export const ADD_POLICY_SUCCESS = 'ADD_POLICY_SUCCESS'
export const ADD_POLICY_FAILURE = 'ADD_POLICY_FAILURE'

export const UPDATE_POLICY_REQUEST = 'UPDATE_POLICY_REQUEST'
export const UPDATE_POLICY_SUCCESS = 'UPDATE_POLICY_SUCCESS'
export const UPDATE_POLICY_FAILURE = 'UPDATE_POLICY_FAILURE'

export const DELETE_POLICY_REQUEST = 'DELETE_POLICY_REQUEST'
export const DELETE_POLICY_SUCCESS = 'DELETE_POLICY_SUCCESS'
export const DELETE_POLICY_FAILURE = 'DELETE_POLICY_FAILURE'

// Escalation Matrix types
export const FETCH_ESCALATION_MATRIX_REQUEST = 'FETCH_ESCALATION_MATRIX_REQUEST'
export const FETCH_ESCALATION_MATRIX_SUCCESS = 'FETCH_ESCALATION_MATRIX_SUCCESS'
export const FETCH_ESCALATION_MATRIX_FAILURE = 'FETCH_ESCALATION_MATRIX_FAILURE'

// fetch grievacne by sections
export const FETCH_GRIEVANCE_SECTIONS_REQUEST = "FETCH_GRIEVANCE_SECTIONS_REQUEST";
export const FETCH_GRIEVANCE_SECTIONS_SUCCESS = "FETCH_GRIEVANCE_SECTIONS_SUCCESS";
export const FETCH_GRIEVANCE_SECTIONS_FAILURE = "FETCH_GRIEVANCE_SECTIONS_FAILURE";


// fetch grievacne by section id 
export const FETCH_GRIEVANCES_BY_SECTION_REQUEST = "FETCH_GRIEVANCES_BY_SECTION_REQUEST";
export const FETCH_GRIEVANCES_BY_SECTION_SUCCESS = "FETCH_GRIEVANCES_BY_SECTION_SUCCESS";
export const FETCH_GRIEVANCES_BY_SECTION_FAILURE = "FETCH_GRIEVANCES_BY_SECTION_FAILURE";




export const FETCH_GRANTS_BY_SECTION_REQUEST = "FETCH_GRANTS_BY_SECTION_REQUEST";
export const FETCH_GRANTS_BY_SECTION_SUCCESS = "FETCH_GRANTS_BY_SECTION_SUCCESS";
export const FETCH_GRANTS_BY_SECTION_FAILURE = "FETCH_GRANTS_BY_SECTION_FAILURE";








